import 'react-app-polyfill/ie11'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'mobx-react'
import AppIndividual from './AppIndividual'
import RootStore from './stores/RootStore'
import { BrowserRouter } from 'react-router-dom'

import './index.scss'
import './styles/index.scss'
import './styles/BankId.scss'
import './styles/ClearButton.scss'
import './styles/Dropzone.css'
import './styles/ExpandingSection.scss'
import './styles/Grid.scss'
import './styles/InfoButton.scss'
import './styles/Loader.scss'
import './styles/ModalBase.scss'
import './styles/nav.scss'
import './styles/NotationButton.scss'
import './styles/NotationBox.scss'
import './styles/NotationCombo.scss'
import './styles/NumberedNotification.scss'
import './styles/PhoneNumberInput.scss'
import './styles/Progress.scss'
import './styles/RadioButton.scss'
import './styles/RadioButtonGroup.scss'
import './styles/RadioButtonWithAttachment.scss'
import './styles/ReadReportContent.scss'
import './styles/ReadReportMenu.scss'
import './styles/Report.scss'
import './styles/ReportNotificationModal.scss'
import './styles/RoundArrowButton.scss'
import './styles/ScrollView.scss'
import './styles/SearchInput.scss'
import './styles/TermsOfDeliveryModal.scss'
import './styles/TextButton.scss'
import './styles/TextInput.scss'
import './styles/TooltipButton.scss'
import './styles/Upload.css'
import './styles/Modal.scss'
import './styles/CloseButton.scss'
import {
	responsiveFontSizes,
	createTheme,
	ThemeProvider,
} from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import { IntlProviderWrapper } from './IntlProviderWrapper'
import $http from './utils/$http'

if (!Intl.PluralRules) {
	require('@formatjs/intl-pluralrules/polyfill')
	require('@formatjs/intl-pluralrules/dist/locale-data/sv')
	require('@formatjs/intl-pluralrules/dist/locale-data/en')
}

if (!(Intl as { RelativeTimeFormat?: Function }).RelativeTimeFormat) {
	require('@formatjs/intl-relativetimeformat/polyfill')
	require('@formatjs/intl-relativetimeformat/dist/locale-data/sv')
	require('@formatjs/intl-relativetimeformat/dist/locale-data/en')
}
$http._baseUrl = process.env.REACT_APP_INDIVIDUALAPI_BASEURL
const rootstore: RootStore = new RootStore()

const theme = responsiveFontSizes(
	createTheme({
		typography: {
			htmlFontSize: 10,
			// fontFamily: 'Arial',
		},
		palette: {
			primary: { main: '#0098C3' },
		},
	}),
)


ReactDOM.render(
	<Provider rootStore={rootstore}>
			<IntlProviderWrapper languageSettings={rootstore.userStore.languageSettings}>
				<ThemeProvider theme={theme}>
					<CssBaseline>
						<BrowserRouter>

							<AppIndividual />
						</BrowserRouter>
					</CssBaseline>
				</ThemeProvider>
			</IntlProviderWrapper>
	</Provider>,
	document.getElementById('root'),
)
